import ClickMixSVG from '../public/integracoes/ClickMix.svg'
import CobrancaSVG from '../public/integracoes/Cobrança.svg'
import ComandasSVG from '../public/integracoes/comandas.svg'
import FidelidadeSVG from '../public/integracoes/Fidelidade.svg'
import IfoodSVG from '../public/integracoes/Ifood.svg'
import LojaIntegradaSVG from '../public/integracoes/Loja integrada.svg'
import MercadoPagoSVG from '../public/integracoes/Mercado pago.svg'
import MobileSVG from '../public/integracoes/Mobile.svg'
import NuvemShopSVG from '../public/integracoes/Nuvem shop.svg'
import OSuperSVG from '../public/integracoes/O super.svg'
import PedidosSVG from '../public/integracoes/Pedidos.svg'
import PidoMeSVG from '../public/integracoes/Pido.me.svg'
import RevisaoSVG from '../public/integracoes/Revisão.svg'
import S2PaySVG from '../public/integracoes/S2Pay.svg'
import SetoresSVG from '../public/integracoes/Setores.svg'
import SiteMercadoSVG from '../public/integracoes/Site mercado.svg'
import SupermercadosNowSVG from '../public/integracoes/Supermercados Now.svg'
import TerminalProducaoSVG from '../public/integracoes/Terminal produção.svg'
import InventarioSVG from '../public/integracoes/Inventario.svg'
import V4TarefasSVG from '../public/integracoes/V4 - tarefas.svg'
import V4SVG from '../public/integracoes/V4.svg'

export const ClickMix = () => {
    return ClickMixSVG
}
export const Cobranca = () => {
    return CobrancaSVG
}
export const Comandas = () => {
    return ComandasSVG
}
export const Fidelidade = () => {
    return FidelidadeSVG
}
export const Ifood = () => {
    return IfoodSVG
}
export const LojaIntegrada = () => {
    return LojaIntegradaSVG
}
export const MercadoPago = () => {
    return MercadoPagoSVG
}
export const Mobile = () => {
    return MobileSVG
}
export const NuvemShop = () => {
    return NuvemShopSVG
}
export const OSuper = () => {
    return OSuperSVG
}
export const Pedidos = () => {
    return PedidosSVG
}
export const PidoMe = () => {
    return PidoMeSVG
}
export const Revisao = () => {
    return RevisaoSVG
}
export const S2Pay = () => {
    return S2PaySVG
}
export const Setores = () => {
    return SetoresSVG
}
export const SiteMercado = () => {
    return SiteMercadoSVG
}
export const SupermercadosNow = () => {
    return SupermercadosNowSVG
}
export const TerminalProducao = () => {
    return TerminalProducaoSVG
}
export const Inventario = () => {
    return InventarioSVG
}
export const V4Tarefas = () => {
    return V4TarefasSVG
}
export const V4 = () => {
    return V4SVG
}